<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-12 mb-5">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#53b000"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 mb-3" v-if="!isSubmit">
        <b-button
          variant="secondary"
          @click="prevClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>
      </div>
      <div class="col-md-12 ">
        <h4>
          Package: {{ package.type }}
          {{ package.duration }} [Start Date: {{ getPayment.activate_date }}]
        </h4>
        <h4>Member: {{ cardId }} - {{ memberName }}</h4>
        <hr class="mt-4" />
      </div>
      <div class="col-md-12 ">
        <h3>Payment: {{ getPayment.total }} Baht by {{ getPayment.paidby }}</h3>
      </div>

      <div class="col-md-12 " v-if="package.duration=='5D' || package.duration=='10D' ">
        <hr class="mt-4" />
        <h4>
          QR Code:
        </h4>
        <h4> Phone - {{ getQrcode.member_phone }} </h4>
        <h4> Email - {{ getQrcode.member_email }}</h4>
        <hr class="mt-4" />
      </div>
    </div>
    <div
      v-if="!isSubmit && !saleLoading"
      class="mt-4 d-flex justify-content-center"
    >
      <b-button
        size="lg"
        block
        variant="primary"
        @click.prevent="CfSubmit"
      >Comfirm</b-button>
      
    </div>
    <div v-else-if="saleLoading" class="text-center">
      <b-spinner variant="success" label="Spinning"></b-spinner>
    </div>
    <div
      v-else
      class="mt-4 justify-content-center"
    >
      <div
        class="alert alert-success"
        role="alert"
      >
        Sale Completed.
        <a
          href="#"
          @click.prevent="resetSale"
        >Click here to start again.</a>
      </div>
    </div>
    <div class="mt-4 justify-content-center d-flex " v-if="qrcodeObj">
      <b-button
        size="lg"
        variant="warning"
        @click.prevent="displayQR()"
      >View QR Code</b-button>
    </div>
    <b-container class="bv-example-row">
        <b-row>
            <b-col>
              <modal name="qrgenbox"
                          :width="500"
                          :height="500"
                          :adaptive="true"
                          >
                <div class="m-4">
                  <h4 class="text-center">{{(qrcodeObj!=null)?formatTypeCoupon(qrcodeObj.type):""}}</h4>
                </div>
                <div v-if="qrnum" class="output">
                    <b-img :src="newQRCode" alt="QRCode" center />
                </div>
                <h4 class="mt-4 text-center">{{ (qrcodeObj!=null)?qrcodeObj.qr_number:"" }}</h4>
            </modal></b-col>
        </b-row>
        </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import QRious from "qrious";
import VModal from "vue-js-modal";
Vue.use(VModal, {  });

import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
export default {
  data() {
    return {
      mySteps: ["Package", "Member", "Payment", "Complete"],
      currentStep: 3,
      isSubmit: false,
      qrcodeObj:null,
      qrnum:null,
      qrcodedisplay: new QRious({ size: 300 }),
      saleLoading:false,
    };
  },
  computed: {
    package() {
      return this.$store.getters.getSalePackage;
    },
    cardId() {
      if (this.$store.getters.getSaleMember == null) {
        return "None";
      }
      return this.$store.getters.getSaleMember.cardid;
    },
    memberName() {
      if (this.$store.getters.getSaleMember == null) {
        return "Walk In";
      }
      let membername =
        this.$store.getters.getSaleMember.firstname +
        " " +
        this.$store.getters.getSaleMember.lastname;
      return membername;
    },
    getPayment() {
      return this.$store.getters.getSalePayment;
    },
    getQrcode() {
      return this.$store.getters.getSaleQrcode;
    },
    newQRCode() {
      
        this.qrcodedisplay.value = this.qrnum;
        return this.qrcodedisplay.toDataURL();
    },
  },
  methods: {
    prevClick() {
      this.$store.dispatch("setSaleState", 2);
    },
    showModal() {
      this.$modal.show(
        'qrgenbox',
        {
        },
        {
        },
        {
          //-- Modal event listener
          "before-close": event => {
            
          },
          "before-open": event => {

          }
        },
        {}
      );
    },
    displayQR(){
      this.showModal();
      //this.$emit("close");
    },
    async CfSubmit() {
      this.currentStep = 4;
      let self = this;
      this.saleLoading = true;
      await axios
        .post("/api/purchases/buy", {
          member: this.$store.getters.getSaleMember,
          purchase: this.$store.getters.getSalePayment,
          package: this.$store.getters.getSalePackage,
          qrcode: this.$store.getters.getSaleQrcode,
          employee_id: this.$store.getters.getSaleEmployee
        })
        .then(response => {
          this.isSubmit = true;
          localStorage.setItem(
            "latestMember",
            JSON.stringify(this.$store.getters.getSaleMember)
          );

          if(response.data.qrcode !=null){
            self.qrcodeObj = response.data.qrcode;
            //console.log(self.qrcodeObj);
            self.qrnum = self.qrcodeObj.qr_number;
          }
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          /* setTimeout(function() {
            this.isSubmit = false;
            self.resetSale();
          }, 500); */

        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => (this.saleLoading = false));
    },

    resetSale() {
      this.$store.dispatch("resetSale");
    },
    formatTypeCoupon(type){
      switch (type) {
        case '5D':
          return '5 DAYS PASS'
          break;
      case '10D':
          return '10 DAYS PASS'
          break;
      case '20D':
          return '20 DAYS PASS'
          break;
      }
    },
  },
  components: {
    "step-progress": StepProgress
  },
  mounted() {
    //console.log(this.$store.getters.getSaleMember);
  }
};
</script>
<style scoped>
.fa-spinner {
  font-size: 2em;
}
</style>
